<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  variant: ChipIntent
  size: ChipSize
  color?: ChipColor
  iconLeft?: IconDefinition
  iconRight?: IconDefinition
}>(), {
  color: 'blurple',
  iconLeft: undefined,
  iconRight: undefined,
})

const attrs = useAttrs()

const isInteractive = computed(() => attrs.onClick !== undefined)

// Let caller classes override default classes
const rootClass = computed(() => mergeClass(
  chipVariants({
    intent: props.variant,
    size: props.size,
    color: props.color,
    interactive: isInteractive.value,
  }),
  attrs.class as string,
))

const rootAttrs = computed(() => {
  const rest = { ...attrs }
  delete rest.class
  return rest
})
</script>

<template>
  <component :is="isInteractive ? 'button' : 'div'" v-bind="rootAttrs" :class="rootClass">
    <Icon v-if="iconLeft" :icon="iconLeft" class="text-[currentColor]" />
    <slot />
    <Icon v-if="iconRight" :icon="iconRight" class="text-[currentColor]" />
  </component>
</template>
